import React from 'react';
import { ButtonIcon, IconEdit } from '@spotify-internal/encore-creator-web';

type PencilButtonProps = {
  className?: string;
  testIdPrefix?: string;
  onClick: () => void;
};
export const PencilButton = ({
  className,
  onClick,
  testIdPrefix,
  ...props
}: PencilButtonProps) => {
  return (
    <ButtonIcon
      className={className}
      data-testid={`${testIdPrefix || ''}edit-button`}
      onClick={onClick}
      {...props}
    >
      <IconEdit aria-hidden focusable={false} />
    </ButtonIcon>
  );
};
